import { Device, MATCH_START } from "callable-data-objects";
import { MenuSearch } from "Components/Shared";
import { useDevice } from "Hooks/Endpoints";
import React, { Fragment, useState } from "react";
import { Button, Container, Header, Menu, Table } from "semantic-ui-react";
import CreateOutboundFlowForm from "./CreateOutboundFlowForm";
import OutboundFlow from "./OutboundFlow";

type OutboundFlowsProps = {
  flows: Device[];
  onSelect: Function;
  title: string;
};

const OutboundFlows = ({ flows, onSelect, title }: OutboundFlowsProps) => {
  const { createDeviceByType, createDevice, device } = useDevice();
  const [search, setSearch] = useState("");
  const filteredFlows = flows.filter(
    (d) => d.name.indexOf(search) > -1 || d.extension.indexOf(search) > -1
  );

  if (createDevice) {
    return <CreateOutboundFlowForm />;
  }

  if (device) {
    return <OutboundFlow />;
  }

  return (
    <Fragment>
      <Menu fluid stackable>
        <Menu.Item header>Outbound Flows</Menu.Item>
        <Menu.Item
          icon='plus'
          name={`Create ${title}`}
          onClick={() => createDeviceByType(MATCH_START)}
        />
        <Menu.Menu position='right'>
          <MenuSearch
            placeholder='Search...'
            onSearch={(value: string) => setSearch(value)}
            value={search}
          />
        </Menu.Menu>
      </Menu>
      <Container fluid>
        <Table celled padded stackable>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width={2} singleLine>
                Name
              </Table.HeaderCell>
              <Table.HeaderCell width={2} singleLine>
                Extension
              </Table.HeaderCell>
              <Table.HeaderCell width={2} singleLine>
                Regex
              </Table.HeaderCell>
              <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {filteredFlows.map((device) => (
              <Table.Row key={`device-${device.id}`}>
                <Table.Cell singleLine>
                  <Header as='h4'>{device.name}</Header>
                </Table.Cell>
                <Table.Cell singleLine>{device.extension}</Table.Cell>
                <Table.Cell singleLine>{device.regexRoute.regExp}</Table.Cell>
                <Table.Cell textAlign='left'>
                  <Button
                    primary
                    size='tiny'
                    onClick={() => onSelect(device.id)}
                  >
                    View
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Container>
    </Fragment>
  );
};

export default OutboundFlows;
